var render = function render(){var _vm=this,_c=_vm._self._c;return _c('animate-push-on-panel',{staticClass:"slice-body-text my-70 text-14 md_text-16 xl_text-18 md_px-20 flex flex-wrap justify-start items-start bold-is-teal"},[_c('div',{staticClass:"w-full md_w-3x12 px-20 textbody spacer"}),_c('div',{staticClass:"w-full px-20 md_w-6x12 textbody",domProps:{"innerHTML":_vm._s(_vm.slice.embedCode)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }